"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var typography_1 = require("../typography");
var icons_1 = require("../../icons");
var DynamicIcon_1 = require("../DynamicIcon");
var AlertVariantStyles = (_a = {},
    _a['success'] = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    border-color: ", ";\n  "], ["\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.background.success;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.border.success;
    }),
    _a['warning'] = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    border-color: ", ";\n  "], ["\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.background.warning;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.border.warning;
    }),
    _a['error'] = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-color: ", ";\n    border-color: ", ";\n  "], ["\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.background.error;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.border.error;
    }),
    _a['info'] = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background-color: ", ";\n    border-color: ", ";\n  "], ["\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.background.info;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.border.info;
    }),
    _a);
var AlertVariantIcon = (_b = {},
    _b['success'] = icons_1.CheckCircle,
    _b['warning'] = icons_1.ExclamationCircle,
    _b['error'] = icons_1.ExclamationCircle,
    _b['info'] = icons_1.InformationCircle,
    _b);
var AlertOuterPadding = (_c = {},
    _c['small'] = (_d = {},
        _d['horizontal'] = '12px',
        _d['vertical'] = '20px',
        _d),
    _c['medium'] = (_e = {},
        _e['horizontal'] = '20px',
        _e['vertical'] = '24px',
        _e),
    _c);
var AlertOuter = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  display: flex;\n  ", "\n  align-items: center;\n  padding: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-radius: ", "px;\n"], ["\n  ", ";\n  display: flex;\n  ", "\n  align-items: center;\n  padding: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-radius: ", "px;\n"])), function (_a) {
    var variant = _a.variant;
    return AlertVariantStyles[variant];
}, function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === 'vertical' && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      flex-direction: column;\n    "], ["\n      flex-direction: column;\n    "])));
}, function (_a) {
    var $size = _a.$size, $orientation = _a.$orientation;
    return AlertOuterPadding[$size][$orientation];
}, design_system_theme_1.BorderRadii.radius16);
var AlertCopyContainer = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  ", "\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  ", "\n  flex-wrap: wrap;\n"])), function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === 'vertical' && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      flex-direction: column;\n      margin-top: 12px;\n    "], ["\n      flex-direction: column;\n      margin-top: 12px;\n    "])));
});
var AlertTitleFontSizes = (_f = {},
    _f['small'] = (_g = {},
        _g['horizontal'] = [design_system_theme_1.FontSizes.fontSize14],
        _g['vertical'] = [design_system_theme_1.FontSizes.fontSize16],
        _g),
    _f['medium'] = (_h = {},
        _h['horizontal'] = [design_system_theme_1.FontSizes.fontSize18],
        _h['vertical'] = [design_system_theme_1.FontSizes.fontSize18],
        _h),
    _f);
var AlertTitle = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var $size = _a.$size, $orientation = _a.$orientation, theme = _a.theme;
    return ({
        sizes: AlertTitleFontSizes[$size][$orientation],
        color: theme.colors.staticPalette.black,
        weight: theme.typography.fontWeights.semiBold,
    });
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), function (_a) {
    var alertHasBodyText = _a.alertHasBodyText;
    return alertHasBodyText && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      margin-right: 4px;\n    "], ["\n      margin-right: 4px;\n    "])));
}, function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === 'vertical' && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      text-align: center;\n    "], ["\n      text-align: center;\n    "])));
});
var AlertBodyFontSizes = (_j = {},
    _j['small'] = (_k = {},
        _k['horizontal'] = [design_system_theme_1.FontSizes.fontSize14],
        _k['vertical'] = [design_system_theme_1.FontSizes.fontSize14],
        _k),
    _j['medium'] = (_l = {},
        _l['horizontal'] = [design_system_theme_1.FontSizes.fontSize18],
        _l['vertical'] = [design_system_theme_1.FontSizes.fontSize16],
        _l),
    _j);
var AlertBody = (0, styled_components_1.default)(AlertTitle).attrs(function (_a) {
    var theme = _a.theme, $size = _a.$size, $orientation = _a.$orientation;
    return ({
        weight: theme.typography.fontWeights.regular,
        sizes: AlertBodyFontSizes[$size][$orientation],
    });
})(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  > p {\n    margin: 0px;\n  }\n"], ["\n  > p {\n    margin: 0px;\n  }\n"])));
var AlertIconSize = (_m = {},
    _m['small'] = (_o = {},
        _o['horizontal'] = 24,
        _o['vertical'] = 24,
        _o),
    _m['medium'] = (_p = {},
        _p['horizontal'] = 24,
        _p['vertical'] = 32,
        _p),
    _m);
var AlertIcon = (0, styled_components_1.default)(DynamicIcon_1.DynamicIcon).attrs(function (_a) {
    var variant = _a.variant, theme = _a.theme, $size = _a.$size, $orientation = _a.$orientation;
    return ({
        primaryColor: theme.colors.border[variant],
        width: AlertIconSize[$size][$orientation],
        height: AlertIconSize[$size][$orientation],
    });
})(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  flex-shrink: 0;\n"], ["\n  ", "\n\n  ", "\n\n  flex-shrink: 0;\n"])), function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === 'vertical' && (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      align-self: center;\n    "], ["\n      align-self: center;\n    "])));
}, function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === 'horizontal' && (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      margin-right: 12px;\n      margin-top: 2px;\n    "], ["\n      margin-right: 12px;\n      margin-top: 2px;\n    "])));
});
/**
 * A component used for displaying information of a given level of severity.
 */
var Alert = function (_a) {
    var variant = _a.variant, size = _a.size, _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b, title = _a.title, body = _a.body, bodyContainsMarkup = _a.bodyContainsMarkup, children = _a.children, className = _a.className;
    var Icon = AlertVariantIcon[variant];
    return (react_1.default.createElement(AlertOuter, { variant: variant, "$size": size, "$orientation": orientation, className: className },
        react_1.default.createElement(AlertIcon, { Icon: Icon, variant: variant, "$orientation": orientation, "$size": size, "aria-hidden": "true" }),
        react_1.default.createElement(AlertCopyContainer, { "$orientation": orientation },
            react_1.default.createElement(AlertTitle, { "$size": size, "$orientation": orientation, alertHasBodyText: Boolean(body) }, title),
            body ? (bodyContainsMarkup ? (react_1.default.createElement(AlertBody, { "$size": size, "$orientation": orientation, dangerouslySetInnerHTML: { __html: body } })) : (react_1.default.createElement(AlertBody, { "$size": size, "$orientation": orientation }, body))) : null),
        children));
};
exports.Alert = Alert;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;
